import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";
import { ThemeApiStructure } from "@interfaces/theme";

export const localTheme: ThemeApiStructure = {
  id: import.meta.env.VITE_ENV === "PROD" ? "" : "49f931c1-d705-4b02-a710-a5da2e0fdec1",
  name: "incredit",
  display_name: "Incredit",
  description: "",
  code: "",
  url_site: "/solicita_tu_credito",
  url_privacy_notice: import.meta.env.VITE_URL_HOME_LENDIA + "/aviso-de-privacidad",
  url_terms_and_conditions: import.meta.env.VITE_URL_HOME_LENDIA + "/terminos-y-condiciones",
  palette: {
    palette: {
      primary: {
        base: "#E3F2F8", // base 30%
        dark: "#001E3E", // obscuro
        main: "#001E3E", // color 2
        light: "#A1BCD9", // color 1
        accent: "#FF802C", // accents
      },
      components: {},
    },
    interface: {
      navbar: {
        logo: "incredit/portal/logos/logo.png",
        logo_width: 40,
        logo_height: "auto",
      },
      lateral: {
        bg_dark: "#001E3E",
        bg_light: "#001E3E",
        logo_bg_dark: "",
        text_bg_dark: "#FFFFFF",
        logo_bg_light: "",
        text_bg_light: "#FFFFFF",
        logo_width: 250,
        logo_height: "auto",
      },
      metadata: {
        title: "Incredit",
        favicon: "incredit/portal/logos/favicon.ico",
      },
    },
  },
};

export const interfaceConfig: InterfaceConfig = {
  name: "incredit",
  home_url: "/solicita_tu_credito",
  aviso_privacidad: import.meta.env.VITE_URL_HOME_LENDIA + "/aviso-de-privacidad",
  terminos_condiciones: import.meta.env.VITE_URL_HOME_LENDIA + "/terminos-y-condiciones",
  interest_rate: 30,
  metadata: {
    title: "Incredit",
    description:
      "Incredit es una plataforma de crédito para PyMEs que ofrece créditos especializados para PyMEs con tasas competitivas y procesos ágiles. Obtén el financiamiento que tu empresa necesita para crecer.",
    favicon: "incredit/portal/logos/favicon.ico",
    ogImage: "https://demo-clientes-incredit.lendia.mx/opengraph-image.png?5ab5b324c6780cbc",
  },
  textos_tofu: {
    pfae: {
      datos_empresa_pfae: {
        titulo: "Registro de empresa",
        sub_titulo: "Ingresa los datos de la persona física con actividad empresarial",
      },
    },
  },
  companyNames: ["Lendit Group SAPI de CV"],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario de la empresa mencionada en esta solicitud.",
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_BeRV6uYmO",
      userPoolClientId: "208j2kkvh8r32d2a9qq926t33f",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_Y0yNT5nH4",
      userPoolClientId: "78ctmcltm4h9r5g3lgie7fl65f",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
};
